import { distinctUntilChanged } from 'rxjs';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, Output } from '@angular/core';
import type { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { type AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import * as FlatModels from "@medsurf/flat-models";

@Component({
    selector: 'medsurf-design-form-control-input-textarea',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './textarea.input.form-control.design.html',
    styleUrls: ['./textarea.input.form-control.design.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    standalone: false
})
export class TextareaInputFormControlDesign implements OnInit, OnChanges {
  @Input() formField = true;
  @Input({ required: true }) control!: AbstractControl;
  @Input() rows?: number;
  @Input() cols?: number;
  @Input() inputClass: FlatModels.TextDesignModels.TextDesignClass = FlatModels.TextDesignModels.TextDesignClass.DEFAULT;
  @Input() autoResize = true;
  @Input() placeholder = "";
  @Input() label?: string;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter<Event>();
  
  name: string;

  constructor(private cd: ChangeDetectorRef, private destroyRef: DestroyRef) {
  }

  ngOnInit() {
    const formGroup = this.control.parent;
    const name = formGroup ? Object.keys(formGroup.controls).find(name => this.control === formGroup.get(name)) : undefined;
    if (!name) {
      throw new FlatModels.ErrorControlModels.MedsurfError(
        'notification.form_control_name_not_found',
        FlatModels.ErrorControlModels.ErrorLevel.enum.error,
        FlatModels.ErrorControlModels.ErrorInstance.enum.AUTHOR,
        "LIBS.FlatDesign.TextareaInputFormControlDesign.ngOnInit"
      );
    }
    this.name = name;
    this.control?.statusChanges.pipe(takeUntilDestroyed(this.destroyRef), distinctUntilChanged()).subscribe(() => {
      this.cd.markForCheck();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']?.currentValue) {
      this.control?.disable();
    } else {
      this.control?.enable();
    }
  }
}
